export const secondsToDateString = (seconds: number): string => new Date(seconds * 1000).toISOString().substr(11, 8);

export const apiBasePath: string = process.env.REACT_APP_API_BASE_PATH || "";